import React, {Component} from 'react';
import {connect} from 'formik';
import {parsers} from '@neosvoc/nv-platform-core-common';
import {DragDropContext, Droppable, Draggable} from 'react-beautiful-dnd';
import dragHandle from '../../../../res/images/drag-handle.svg';
import messages from '../../../../res/translations/messages';
import {FormattedMessage} from 'react-intl';

const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

class RankType extends Component {
    constructor(props) {
        super(props);

        const {rows} = this.props;

        this.state = {
            rows,
            currentMax: 0,
        };

        this.validate = this.validate.bind(this);
        this.onDragEnd = this.onDragEnd.bind(this);
        this.onChange = this.onChange.bind(this);

        const value = rows.reduce((acc, item, index) => {
            acc[item.id] = index+1;
            return acc;
        }, {});
        this.props.formik.setFieldValue(this.props.id, value);
    }

    componentDidMount() {
        this.props.formik.registerField(this.props.id, this);
    }

    componentWillUnmount() {
        this.props.formik.unregisterField(this.props.id);
    }

    validate(value) {
        try {
            parsers.rank(value, Object.assign({}, this.props, {currentMax: this.state.currentMax}));
        } catch (err) {
            console.log(err);
            return err.payload;
        }
    }

    onChange(e) {
        const index = parseInt(e.target.dataset['index']);

        const result = {
            destination: {index: e.target.value - 1},
            source: {index: index},
        };
        this.onDragEnd(result);
    }

    async onDragEnd(result) {
        const {id, formik} = this.props;
        let {max} = this.props;

        if (max === null) {
            max = this.state.rows.length;
        }

        const {destination} = result;

        // dropped outside the list
        if (!destination) {
            return;
        }

        const rows = reorder(
            this.state.rows,
            result.source.index,
            result.destination.index,
        );

        let currentMax = result.destination.index+1;
        if (currentMax < this.state.currentMax) currentMax = this.state.currentMax;
        if (currentMax > max) currentMax = max;

        const value = rows.reduce((acc, item, index) => {
            acc[item.id] = index+1;
            return acc;
        }, {});
        await formik.setFieldValue(id, value);
        this.setState({
            rows,
            currentMax,
        });
        formik.setFieldTouched(id, true);
    }

    render() {
        let {max} = this.props;

        if (max === null) {
            max = this.state.rows.length;
        }

        const options = Array.from({length: this.state.rows.length}, (_, i) => i + 1);
        const isValid = this.state.currentMax >= max;
        return (
            <DragDropContext onDragEnd={this.onDragEnd}>
                <div className="row">
                    <div style={{paddingBottom: '26px'}} className="col-10">
                        <Droppable droppableId="droppable">
                            {(provided, snapshot) => (
                                <div
                                    {...provided.droppableProps}
                                    ref={provided.innerRef}
                                >
                                    {this.state.rows.map((row, rowIndex) => (
                                        <Draggable
                                            key={''+row.id}
                                            draggableId={''+row.id}
                                            index={rowIndex}
                                        >
                                            {(provided, snapshot) => (
                                                <div
                                                    ref={provided.innerRef}
                                                    {...provided.dragHandleProps}
                                                    {...provided.draggableProps}
                                                    className="pb20"
                                                >
                                                    <div key={row.id}>
                                                        <div className="form-group clear-both">
                                                            <div className="float-left pr10 mt10">
                                                                <div className="icon14">
                                                                    <img src={dragHandle} className="icon" />
                                                                </div>
                                                            </div>
                                                            <div className="float-left pr10 mt10" dangerouslySetInnerHTML={{__html: row.label}} />
                                                            <div className="float-right pr10">
                                                                <select className="form-control" data-index={rowIndex}
                                                                    value={this.state.currentMax > rowIndex && rowIndex+1} onChange={this.onChange}>
                                                                    <option value=""> - </option>
                                                                    {options.map((option) => (
                                                                        <option key={option} value={option}>
                                                                            {option}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </Draggable>
                                    ))}
                                    {provided.placeholder}
                                </div>
                            )}
                        </Droppable>
                    </div>
                </div>
                {isValid && (<div>
                    <span className="info-primary">
                        <FormattedMessage {...messages.label.required_ordered_elements_reached} />
                    </span>
                </div>)}
            </DragDropContext>
        );
    }
}

export default connect(RankType);
